import { MediaTypeModel } from './media-type.model';

export class SelectedMediaTypesFilterModel {
    mediaTypes: MediaTypeModel[];
    archivedOnly: boolean;

    constructor(mediaTypes: MediaTypeModel[], archivedOnly: boolean) {
        this.mediaTypes = mediaTypes;
        this.archivedOnly = archivedOnly;
    }

    /**
     * Returns a clone of the model
     */
    clone(): SelectedMediaTypesFilterModel {
        return new SelectedMediaTypesFilterModel(
            this.mediaTypes.slice(),
            this.archivedOnly
        );
    }
}
